import { getRoute } from '@utils/route';

export const INSURANCE_POLICY_BUY_ROUTE_URL = '/insurance-policy-buy/*';
export const INSURANCE_POLICY_BUY_NEW_PAGE_URL = '/insurance-policy-buy';
export const INSURANCE_POLICY_BUY_REVIEW_PAGE_URL = '/insurance-policy-buy/:insurancePolicyId/review';
export const INSURANCE_POLICY_BUY_EDIT_PAGE_URL = '/insurance-policy-buy/:insurancePolicyId/edit';
export const INSURANCE_POLICY_BUY_PAY_PAGE_URL = '/insurance-policy-buy/:insurancePolicyId/pay';

type RouteParams = {
  insurancePolicyId: number;
};

export const routeInsurancePolicyBuyNewPage = () => getRoute(INSURANCE_POLICY_BUY_NEW_PAGE_URL);
export const routeInsurancePolicyBuyReviewPage = (routeParams: RouteParams) => getRoute(INSURANCE_POLICY_BUY_REVIEW_PAGE_URL, { routeParams });
export const routeInsurancePolicyBuyEditPage = (routeParams: RouteParams) => getRoute(INSURANCE_POLICY_BUY_EDIT_PAGE_URL, { routeParams });
export const routeInsurancePolicyBuyPayPage = (routeParams: RouteParams) => getRoute(INSURANCE_POLICY_BUY_PAY_PAGE_URL, { routeParams });
